import { CalendarEvent, google, ics, office365 } from "calendar-link";
import { DateTime } from "luxon";

import { routes } from "lib/routes";

type ReminderInterval = {
  value: number;
  unit: "days" | "weeks" | "months" | "years";
};

type CalendarType = "google" | "office365" | "ics";

export type ReminderDataType = "notice" | "framework" | "lead";

export function calculateReminderDate({
  anchorDate,
  startHour,
  reminderInterval,
}: {
  anchorDate: Date;
  reminderInterval: ReminderInterval;
  startHour: number;
}): string {
  const anchor = DateTime.fromJSDate(anchorDate).startOf("day").set({ hour: startHour });
  const reminderDate = anchor.minus({ [reminderInterval.unit]: reminderInterval.value }).toISO();
  if (!reminderDate) {
    throw new Error("Reminder date calculation failed");
  }
  return reminderDate;
}

export function isDateInFuture({
  anchorDate,
  startHour,
  reminderInterval,
}: {
  anchorDate: Date;
  reminderInterval: ReminderInterval;
  startHour: number;
}): boolean {
  const givenDate = DateTime.fromJSDate(anchorDate)
    .startOf("day")
    .set({ hour: startHour })
    .minus({ [reminderInterval.unit]: Number(reminderInterval.value) });
  return givenDate > DateTime.now();
}

export function setHoursOnDate(date: Date, hour: number): string {
  const dateString = DateTime.fromJSDate(date).set({ hour }).toISO();
  if (!dateString) {
    throw new Error("Date string creation failed");
  }
  return dateString;
}

export function createCalenderLink(event: CalendarEvent, type: CalendarType) {
  switch (type) {
    case "google":
      return google(event);
    case "office365":
      return office365(event);
    case "ics":
      return ics(event);
    default:
      throw new Error("Invalid calendar type");
  }
}

const dataTypeToRoute: Record<ReminderDataType, string> = {
  notice: routes.notices,
  framework: routes.frameworks,
  lead: routes.leads,
};

export function generateEventDescription(
  dataType: ReminderDataType,
  dataId: string,
  dataTitle: string,
  calendarType: CalendarType,
): string {
  const url = `${window.location.origin}${dataTypeToRoute[dataType]}/${dataId}`;

  let dataFormatted: string;
  if (calendarType === "ics") {
    dataFormatted = `${dataTitle} - ${url}`;
  } else {
    dataFormatted = `<a href="${url}">${dataTitle}</a>`;
  }

  return `Time to engage with ${dataFormatted} in Stotles.\n\n\n  `;
}
